import type { Locale } from "./types";

export interface PluralForms {
  en: readonly [singular: string, plural: string];
  // Turkish nouns are not marked for plural after an explicit numeral (e.g.
  // "3 tarif", not "3 tarifler"), so there is exactly one Turkish form. It's
  // optional because no Turkish UI-chrome strings have been authored/reviewed
  // yet (see docs/adr/0002-i18n-english-turkish.md); once they land, pass the
  // Turkish noun here and it will be used verbatim regardless of count.
  tr?: string;
}

export function pluralize(
  count: number,
  locale: Locale,
  forms: PluralForms,
): string {
  if (locale === "tr") return forms.tr ?? forms.en[0];
  return count === 1 ? forms.en[0] : forms.en[1];
}
